import axios from "axios"
import { API_BASE_URL, config } from "../../../config/apiConfig"

const register = async (userData) => {
    const response = await axios.post(`${API_BASE_URL}/user/register/`, userData)
    if (response.data) {
        if (response.data) {
            localStorage.setItem("user", JSON.stringify(response.data))
        }
        return response.data
    }
}

const login = async (userData) => {
    const response = await axios.post(`${API_BASE_URL}/user/login/`, userData)
    if (response.data) {
        if (response.data) {
            localStorage.setItem("user", JSON.stringify(response.data))
        }
        return response.data
    }
}

const userProfile = async () => {
    const response = await axios.get(`${API_BASE_URL}/user/profile/`, config)
    console.log("User", response.data);
    if (response.data) {
        return response.data
    }
}


export const authService = {
    register,
    login,
    userProfile,
}
